import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Self-hosted font — no third-party font host at runtime (Iran-safe).
import 'vazirmatn/Vazirmatn-font-face.css';
import './styles/tokens.css';
import './styles/base.css';

import { loadRuntimeConfig } from './core/config';
import { App } from './app/App';

const root = createRoot(document.getElementById('root')!);

loadRuntimeConfig()
  .then(() => {
    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  })
  .catch(() => {
    root.render(
      <div className="page">
        <h1 className="page-title">پیکربندی بارگذاری نشد</h1>
        <p className="help">config.json در دسترس نیست.</p>
        <button type="button" className="btn primary" onClick={() => window.location.reload()}>
          تلاش دوباره
        </button>
      </div>,
    );
  });
